









import Vue from 'vue'
import { mixins } from 'vue-class-component'
import dayjs from 'dayjs'

export default Vue.extend({
  props: {
    dataValue: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      default: null
    },
  },
  data(){
    return {
      tableColumns: [],
      tableData: [],
      bizTypeList: [6,8,11],
      scrollHeight: 200,
      tableKey: {}
    }
  },
  mounted(){
    this.initTableColumns()
    this.getHeight()
  },
  methods:{
    getHeight(){
      const height = document.querySelector('.main-body').clientHeight
      this.scrollHeight = height - 80
    },
    initTableColumns(){
      this.tableKey = {}
      this.tableColumns = [{
        title: this.$t('page_process_parameters_time_name'),
        dataIndex: 'time',
        key: 'time',
        width: 150
      }]
      this.dataValue.forEach(item => {
        const value = {
          title: item.paramDesc,
          dataIndex: item.id,
          key: item.id,
          width: 150,
          customRender:(val) => val !=0 ? val : '-',
        }
        // this.tableKey[item.id] = 0 + (item.unit ? item.unit : "")
        this.tableKey[item.id] = '-'
        this.tableColumns.push(value)
      });
      this.initTableData()
    },
    initTableData(){
      this.tableData = []
      const dict = {}
      for(let value of this.dataValue) {
        if(value.finalEndList){
          for(let l of value.finalEndList) {
            if(!dict[l.reportTime]) {
              dict[l.reportTime] = {
                ...this.tableKey,
                reportTime: l.reportTime,
                time: dayjs(l.reportTime).format('mm:ss.SSS')
              }
            }
            dict[l.reportTime][value.id] = this.addCompany(value.unit,l.value)
          }
        } else{
          continue
        }
      }
      const dataValue = Object.values(dict)
      this.tableData = dataValue.sort((a:any, b:any) => {return a.reportTime - b.reportTime})
    },
    addCompany(unit,value){
      return value ? value + (unit ? unit : '') : '-'
    }
  }
})

